import { supabase } from '../lib/supabase';

export const funnelService = {
  async getAllFunnels(userId) {
    try {
      if (!supabase) return [];
      let query = supabase?.from('sales_funnels')?.select('*')?.order('created_at', { ascending: false });
      if (userId) {
        query = query?.eq('user_id', userId);
      }
      const { data, error } = await query;
      if (error) {
        console.warn('Error fetching funnels:', error?.message);
        return [];
      }
      return data || [];
    } catch (err) {
      console.error('Error in getAllFunnels:', err);
      return [];
    }
  },

  async getFunnelById(funnelId) {
    if (!funnelId) return null;
    try {
      if (!supabase) return null;
      const { data, error } = await supabase
        ?.from('sales_funnels')
        ?.select('*')
        ?.eq('id', funnelId)
        ?.single();
      if (error) {
        console.warn('Error fetching funnel:', error?.message);
        return null;
      }
      return data;
    } catch (err) {
      console.error('Error in getFunnelById:', err);
      return null;
    }
  },

  async createFunnel(funnelData) {
    try {
      if (!supabase) throw new Error('Database not available');
      const { data, error } = await supabase
        ?.from('sales_funnels')
        ?.insert([{
          name: funnelData?.name || 'New Funnel',
          description: funnelData?.description || '',
          type: funnelData?.type || 'lead_generation',
          status: funnelData?.status || 'draft',
          user_id: funnelData?.user_id,
          stages: funnelData?.stages || [],
          settings: funnelData?.settings || {},
          created_at: new Date()?.toISOString(),
          updated_at: new Date()?.toISOString()
        }])
        ?.select()
        ?.single();
      if (error) throw error;
      return data;
    } catch (err) {
      console.error('Error creating funnel:', err);
      throw err;
    }
  },

  async updateFunnel(funnelId, updates) {
    if (!funnelId) throw new Error('Funnel ID required');
    try {
      if (!supabase) throw new Error('Database not available');
      const { data, error } = await supabase
        ?.from('sales_funnels')
        ?.update({ ...updates, updated_at: new Date()?.toISOString() })
        ?.eq('id', funnelId)
        ?.select()
        ?.single();
      if (error) throw error;
      return data;
    } catch (err) {
      console.error('Error updating funnel:', err);
      throw err;
    }
  },

  async deleteFunnel(funnelId) {
    if (!funnelId) throw new Error('Funnel ID required');
    try {
      if (!supabase) throw new Error('Database not available');
      const { error } = await supabase
        ?.from('sales_funnels')
        ?.delete()
        ?.eq('id', funnelId);
      if (error) throw error;
      return true;
    } catch (err) {
      console.error('Error deleting funnel:', err);
      throw err;
    }
  },

  async getFunnelStats(userId) {
    if (!userId) return { total: 0, active: 0, paused: 0, draft: 0 };
    try {
      if (!supabase) return { total: 0, active: 0, paused: 0, draft: 0 };
      const { data, error } = await supabase
        ?.from('sales_funnels')
        ?.select('id, status')
        ?.eq('user_id', userId);
      if (error) return { total: 0, active: 0, paused: 0, draft: 0 };
      const funnels = data || [];
      return {
        total: funnels?.length,
        active: funnels?.filter(f => f?.status === 'active')?.length,
        paused: funnels?.filter(f => f?.status === 'paused')?.length,
        draft: funnels?.filter(f => f?.status === 'draft')?.length
      };
    } catch (err) {
      console.error('Error in getFunnelStats:', err);
      return { total: 0, active: 0, paused: 0, draft: 0 };
    }
  }
};

export default funnelService;